import { render, staticRenderFns } from "./MapPage.vue?vue&type=template&id=528c8b01&scoped=true&"
import script from "./MapPage.vue?vue&type=script&lang=js&"
export * from "./MapPage.vue?vue&type=script&lang=js&"
import style0 from "./MapPage.vue?vue&type=style&index=0&id=528c8b01&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528c8b01",
  null
  
)

export default component.exports